import { mapState } from 'pinia';
import { useWebsiteStore } from '~/units/website/store';

export const TheHeaderMixin = defineNuxtComponent({
  computed: {
    ...mapState(useWebsiteStore, ['headerMenuComponents']),
  },
});
